/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllKioskPlans = (state) => values(get(state, ['kioskPlans', 'items']));

export const requestingKioskPlans = (state) => get(state, ['kioskPlans', 'requesting']);

export const errorRequestingKioskPlans = (state) => get(state, ['kioskPlans', 'error']);